<ng-template appSpotlightFooterInflatorContainer></ng-template>
